module.exports = __webpack_public_path__ + "img/plastics.09fb4dd4.png";